import "./style.scss";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import AODPopUp from "@/src/components/AdmissionsOfficeDatabase/AODPopUp/AODPopUp";
// import AODHeader from "@/src/components/AdmissionsOfficeDatabase/AODHeader/AODHeader";
import AODBody from "@/src/components/AdmissionsOfficeDatabase/AODBody/AODBody";
import AODFooter from "@/src/components/AdmissionsOfficeDatabase/AODFooter/AODFooter";
import { RootState } from "@/src/store";
import { IFiltersList, IRowData } from "@/src/types/applicationOnline";
import { admissionDatabaseRequests } from "@/src/api/admissionOfficeDatabaseRequests";
import { setData, setFilterAndSearch } from "@/src/store/slices/AdmissionOfficeDatabase/AODatabaseTableSlice";
import { useFilteredObject } from "@/src/hooks/useFilteredObject";
import { IADatabaseFilters, IADatabaseSearchAndFilters } from "@/src/types/admissionDatabase";
import AODHeader from "./AODHeader/AODHeader";
import { admissionDatabaseDefaultBodyFilters } from "@/src/constants/AdmissionOffice/admissionOfficeDatabaseConsts";
import { filterRowsByAccess, resolveAccessFilteredCount } from "@/src/utils/accessControl/filterByAccess";

const AODLayout = () => {
  const dispatch = useDispatch();

  let actualOfficeTable = useSelector((state: RootState) => state.applicationsFilters.actualOfficeTable);
  const bodyFilters = useSelector((state: RootState) => state.AODatabaseTable.filterAndSearch);
  const actualFilterStatus = useSelector((state: RootState) => state.applicationsFilters.filterStatus);
  const selectedSiteUrl = useSelector((state: RootState) => state.accessControl.selectedSiteUrl);

  const headerCheckboxRef = useRef<HTMLInputElement>(null);

  const [isShowSettingsModal, setIsShowSettingsModal] = useState(false);
  const [isApPopUpFullName, setIsApPopUpFullName] = useState<boolean>(false);
  const [currentDataPopUp, setCurrentDataPopUp] = useState<IRowData | undefined>();
  const [isCurrentPage, setIsCurrentPage] = useState<string>("1");
  const [isSelectPagination, setIsSelectPagination] = useState<string>("50");

  const [tableFiltersList, setTableFiltersList] = useState<IADatabaseFilters | undefined>();

  const [actualQuantityRows, setActualQuantityRows] = useState<number>(0);

  const bodyFilterFetch = useFilteredObject(bodyFilters);

  const formRef = useRef<HTMLDivElement>(null);

  const updateShowFormClass = () => {
    if (formRef.current) {
      const value = localStorage.getItem("applyOnlineApplications");
      if (value === "show") formRef.current.classList.add("show");
      else formRef.current.classList.remove("show");
    }
  };

  const loadActualData = async () => {
    const hasAnyFilterChanged = Object.keys(admissionDatabaseDefaultBodyFilters)
      .filter((key) => key !== "page")
      .some((key) => {
        const k = key as keyof IADatabaseSearchAndFilters;
        const initialValue = admissionDatabaseDefaultBodyFilters[k];
        const currentValue = bodyFilters[k];

        if (Array.isArray(initialValue)) {
          return (currentValue as string[]).length > 0;
        } else {
          return currentValue !== initialValue && currentValue !== "";
        }
      });

    const officeUrl = selectedSiteUrl.trim() || undefined;
    let dataTable;

    if (hasAnyFilterChanged) {
      dataTable = await admissionDatabaseRequests.filterAndSearch({
        ...bodyFilters,
        ...(officeUrl ? { office_url: officeUrl } : {}),
      });
    } else {
      dataTable = await admissionDatabaseRequests.getListDefault(isCurrentPage, officeUrl);
      if (dataTable) {
        setTableFiltersList(dataTable.filters);
      }
    }

    if (dataTable) {
      const normalizedDocsArray = (dataTable.docsArray ?? []).map((doc) => ({
        ...doc,
        // Backend returns `is_avaliable` (legacy typo); normalize to UI field.
        is_available: doc.is_available ?? doc.is_avaliable ?? true,
        office_url: doc.office_url ?? null,
        form_office: doc.form_office ?? null,
      }));
      const filteredDocs = filterRowsByAccess(normalizedDocsArray, {
        officeUrlQuery: officeUrl,
      });
      dispatch(setData(filteredDocs));
      setActualQuantityRows(
        resolveAccessFilteredCount(filteredDocs.length, normalizedDocsArray.length, dataTable.total),
      );
    }

    console.log(hasAnyFilterChanged ? "Фильтры активны" : "Дефолтный запрос", dataTable);
  };

  useEffect(() => {
    loadActualData();

    window.addEventListener("applyOnlineApplicationsChanged", updateShowFormClass);

    return () => {
      window.removeEventListener("applyOnlineApplicationsChanged", updateShowFormClass);
    };
  }, [isCurrentPage, isSelectPagination, actualOfficeTable, bodyFilters, selectedSiteUrl]);

  useEffect(() => {
    dispatch(setFilterAndSearch({ key: "page", value: Number(isCurrentPage) }));
  }, [isCurrentPage]);

  useEffect(() => {
    setIsCurrentPage("1");
  }, [actualOfficeTable, actualFilterStatus, selectedSiteUrl]);

  return (
    <>
      {/* <div ref={formRef} className="admission-database-form">
        <ApplyOnline loadActualForm={loadActualForm} />
      </div> */}
      <div className="container admission-database">
        {/* <AODPopUp isApPopUpFullName={isApPopUpFullName} setIsApPopUpFullName={setIsApPopUpFullName} currentDataPopUp={currentDataPopUp} />*/}
        <AODHeader
          isShowSettingsModal={isShowSettingsModal}
          setIsShowSettingsModal={setIsShowSettingsModal}
          loadActualData={loadActualData}
        />
        <AODBody
          headerCheckboxRef={headerCheckboxRef}
          setIsApPopUpFullName={setIsApPopUpFullName}
          setIsCurrentPage={setIsCurrentPage}
          setCurrentDataPopUp={setCurrentDataPopUp}
          tableFiltersList={tableFiltersList}
          isShowSettingsModal={isShowSettingsModal}
        />
        <AODFooter
          isCurrentPage={isCurrentPage}
          setIsCurrentPage={setIsCurrentPage}
          isSelectPagination={isSelectPagination}
          setIsSelectPagination={setIsSelectPagination}
          actualQuantityRows={actualQuantityRows}
        />
      </div>
    </>
  );
};

export default AODLayout;
